// extracted by mini-css-extract-plugin
export default {"form":"ResetPassword_form__1GKi+","btn":"ResetPassword_btn__vdU+X"};